import { useQuery } from "@tanstack/react-query";
import { APIClient } from "../constants";

interface IFeeEstimate {
  satsPerVb: number;
  usd: number;
}
interface IFeeEstimateResult {
  fastestFee: IFeeEstimate;
  halfHourFee: IFeeEstimate;
  hourFee: IFeeEstimate;
  minimumFee: IFeeEstimate;
}

export const useFeeEstimate = (bytes?: number) => {
  return useQuery(
    ["fee-estimate", bytes],
    async () => {
      const { data } = await APIClient.get(`/fees/estimate?vb=${bytes ?? 300}`);
      return data as IFeeEstimateResult;
    },
    {
      refetchInterval: 60 * 1000,
    }
  );
};
